import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const PersonIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  strokeWidth = 1.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.333 14v-1.333c0-.708-.281-1.386-.781-1.886S11.373 10 10.666 10H5.333c-.708 0-1.386.281-1.886.781s-.781 1.178-.781 1.886V14M8 7.333c1.473 0 2.667-1.194 2.667-2.666C10.667 3.194 9.473 2 8.001 2 6.528 2 5.334 3.194 5.334 4.667c0 1.472 1.194 2.666 2.667 2.666z"
    />
  </svg>
);
